import {BehaviorSubject} from 'rxjs';

import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {Store} from '@ngrx/store';

@Injectable({
	providedIn: 'root',
})
export class GlobalsService {
	private readonly store: Store = inject(Store);
	private readonly router: Router = inject(Router);

	constructor() {
		this._listenToRouterEvents();
	}

	/* -------------------------------------------  Global Indicators ------------------------------------------- */
	/* ----------------- Navigation ----------------- */
	public static isAppInNavigationProcessSignal$: WritableSignal<boolean> = signal(false);
	public static isAppInNavigationProcess$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	/* --------------------------------------------  Private Methods -------------------------------------------- */
	private _listenToRouterEvents(): void {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				GlobalsService.isAppInNavigationProcessSignal$.set(true);
				GlobalsService.isAppInNavigationProcess$.next(true);
			} else if (event instanceof NavigationEnd) {
				GlobalsService.isAppInNavigationProcessSignal$.set(false);
				GlobalsService.isAppInNavigationProcess$.next(false);
			}
		});
	}
}
